import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router';
import CategoriesDataTable from 'components/categories/CategoriesDataTable';
import { convertQueryParamsIntoObject } from 'constant/Helpers';

const CategoriesPage = () => {
  const [inputValues, setInputValues] = useState({
    type: '-1',
  });
  const location = useLocation();

  useEffect(() => {
    if (location.search) {
      const queryObj = convertQueryParamsIntoObject(location.search);
      setInputValues(queryObj);
    }
  }, []);

  useEffect(() => {
    if (location.search) {
      const queryObj = convertQueryParamsIntoObject(location.search);
      setInputValues(queryObj);
    }
  }, [location.search]);

  return (
    <div>
      <CategoriesDataTable inputValues={inputValues} setInputValues={setInputValues} />
    </div>
  );
};

export default CategoriesPage;
